import React, { useEffect } from 'react';

export default function useWillMount(callback) {
  const isMounted = React.useRef(false);
  if (!isMounted.current) {
    callback();
  }
  useEffect(() => {
    isMounted.current = true;
  }, []);
}
